import React, { useState, useEffect } from "react";
import { Input } from "antd";

import Style from "../questionItem.module.scss";

interface TianKongValue {
    answerId: number;
    stuAnswer: string;
    content: string;
}

interface IProps {
    homeworkState: number;
    list: TianKongValue[];
    onChange: (
        answerId: number,
        value: string,
        userAnswers: TianKongValue[]
    ) => void;
}

export const Tiankong = ({ list, homeworkState, onChange }: IProps) => {
    const [data, setData] = useState<TianKongValue[]>(list);

    const handleChange = (answerId: number, stuAnswer: string) => {
        if (homeworkState === 2) return;
        const newData = data.map(item =>
            item.answerId === answerId ? { ...item, stuAnswer } : item
        );
        setData(newData);
        onChange(answerId, stuAnswer, newData);
    };

    return (
        <>
            {data.map((item, index) => (
                <div
                    key={item.answerId}
                    className={`${Style.option} ${Style.tiankong}`}>
                    {`（${index + 1}）、`}
                    <TiankongItem
                        content={item.stuAnswer}
                        onChange={(value: string) =>
                            handleChange(item.answerId, value)
                        }
                        readOnly={homeworkState === 2}
                    />
                    {homeworkState === 2 && (
                        <span>正确答案: {item.content}</span>
                    )}
                </div>
            ))}
        </>
    );
};

interface TiankongItemProps {
    content: string;
    onChange: (value: string) => void;
    readOnly: boolean;
}

export const TiankongItem = ({
    content,
    onChange,
    readOnly
}: TiankongItemProps) => {
    let [value, setValue] = useState("");
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    const setOptionValue = () => {
        onChange(value);
    };

    useEffect(() => {
        setValue(content);
    }, []);

    return (
        <Input
            onChange={handleChange}
            onBlur={setOptionValue}
            readOnly={readOnly}
            value={value}
            maxLength={200}
        />
    );
};
